import { type CSSProperties, type JSX, useState } from "react";
import { Route, Routes } from "react-router";
import Dashboard from "./Dashboard.tsx";
import Import from "./Import.tsx";

const LayoutProps = Object.freeze({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
} satisfies CSSProperties);

export default function AccountingIndex(): JSX.Element {
  const [accountingServiceAccountClientEmail] = useState(
    "luna-rs@heliopolis.iam.gserviceaccount.com",
  );

  return (
    <div style={LayoutProps}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="import"
          element={
            <Import applicationServiceAccountClientEmail={accountingServiceAccountClientEmail} />
          }
        />
        z
      </Routes>
    </div>
  );
}
